import { getCurrentYear } from '~/utils/date';
import { z } from 'zod';

export const filterSchema = z.object({
  search: z.string().default(''),
  year: z.string().default(String(getCurrentYear())).transform(x => parseInt(x)),
});
